var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.79 4.17143L8.89 0.171429C8.75 0.0571428 8.61 0 8.4 0H1.4C0.63 0 0 0.514286 0 1.14286V14.8571C0 15.4857 0.63 16 1.4 16H12.6C13.37 16 14 15.4857 14 14.8571V4.57143C14 4.4 13.93 4.28571 13.79 4.17143ZM8.4 1.37143L12.32 4.57143H8.4V1.37143ZM12.6 14.8571H1.4V1.14286H7V4.57143C7 5.2 7.63 5.71429 8.4 5.71429H12.6V14.8571Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7998 11.4286H11.1998V12.5714H2.7998V11.4286Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7998 8H11.1998V9.14286H2.7998V8Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.2e113087d75a87bb642e67a0d3f15ae0.svg";
export { ForwardRef as ReactComponent };